
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexI2q4NbfQRrtjq9Rqi2a_45h08_45Z5cV4G_45baFM4Jey8JTAMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/index.vue?macro=true";
import { default as loginXKB97NmOaGKbgGwetMFpfnWx4CNCi0dLuLZt1yebgcsMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/login.vue?macro=true";
import { default as profile_45vrUpheUV7tJCtSbVR59Mi8_eKiU8MXhg45RqPBIZqIMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/profile.vue?macro=true";
import { default as indexQGOU9jtCGxo5_IXyyVMgt_45AGxOkrO0zTmsRgJVPOh4gMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/dashboard/index.vue?macro=true";
import { default as indexA4BtK3cB46i1dlxgCxzSHPLO75PhP_JqxJxj8HH_ieYMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/index.vue?macro=true";
import { default as indexdLAbOai7baIC01ImU3s_45THtKhHbcuJTg37E_455siijFsMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/index.vue?macro=true";
import { default as createZlX6FMoc1gMyUlhV_45MTvcdAV_yRG8k4IwynX6fGjKekMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/create.vue?macro=true";
import { default as createiMs5Gj6Eu8Ci2dymFwfC3uoGMpyVObMG3yOLUtkva_wMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/create.vue?macro=true";
import { default as exportkT7frQg0dwAj_SAmdK7lW8RSv2_hytpNlYsJyz05JdUMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/export.vue?macro=true";
import { default as importVWvdHzFW_MIeMoJq0MFW_pop3r8ta1pWptclVeEryIsMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/import.vue?macro=true";
import { default as edittXNqMcNYedN63N2TY3awG6cw_45xg5eynuxl6NNvNCrEQMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/[id]/edit.vue?macro=true";
import { default as editcY2QuFqEZG8Pvq986Z8jeBey89A8YO_k7iucwG_453WagMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/edit.vue?macro=true";
import { default as indexKfKMAPn2ny4Z6qcAqYbHGcEml0RLPpro46xS7KH_45l58Meta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/users/index.vue?macro=true";
import { default as indexnumF0GzgoNroworkpwIyfcWCzCetf2_kHdmWubKWOrcMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/[id]/index.vue?macro=true";
import { default as indextluEvqWfXIaTyCNK7MRYTgqRNcEEFSp_450iGC_mNylJAMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/index.vue?macro=true";
import { default as createz60aMujR6n8vgHe7FKNGlSsagLRKZZSUMw5A2Kd_AjYMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/users/create.vue?macro=true";
import { default as indexpKhtKgJNQ6WppFV53UoNDu2AwKjD4yI9gLr4nE6rxgMMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/devices/index.vue?macro=true";
import { default as indexHQgLahuLumzqIqh8L4IFQ3eCfZnYMXhlja4vgmBmeCwMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-evidence-headers/index.vue?macro=true";
import { default as create8VADbdUfwayUpVXYT4zqLA6m4RDw3Cm6EpJI0f6yPncMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/devices/create.vue?macro=true";
import { default as createf3TKp4_Yi4iPktDydtb9_teg41bERB0_452dPuGCnry1kMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-evidence-headers/create.vue?macro=true";
import { default as editMeJZ1GwkAm0BBQb0_0NRb0_45JQJpSn4ILm7nzAxBOFXAMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/devices/[id]/edit.vue?macro=true";
import { default as edit9XISsl4T4FL3staz_UtNup1e2S4Rnzszr3gZw999jX8Meta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-evidence-headers/[id]/edit.vue?macro=true";
import { default as indexwpqONQwVcwEbdiGCXEbwGiwJUwDrvJ8AVEWJ4J7WbzEMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/devices/[id]/index.vue?macro=true";
import { default as createCiq75e6T94DjeCISEutilFONE39GZ_jO0lqK_eM_BOcMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/[id]/users/create.vue?macro=true";
import { default as index3r277STtZZ5pulqi9COyABVDnCMhKVCittGVvZFuo2oMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-evidence-headers/[id]/index.vue?macro=true";
import { default as indexYrJSV2tJRQxS_455Jqarq1I6CahxZSKsZ_8aEyTr1yTpYMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/cars/index.vue?macro=true";
import { default as createDx2RNKtj15XU2KxHZiwlZW_45lWLvpuCYEhCd_Lj5fQjwMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/cars/create.vue?macro=true";
import { default as create18V2rONGdQ2Ixpn2zgzGsDJBEb5TAwKngTB614s1_45tMMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/subjects/create.vue?macro=true";
import { default as indexIKWcURFiO27ekvBoogI8rUOoXONZcnu1UzSC5xEVbUUMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/index.vue?macro=true";
import { default as indexfXkwn1sqiloejmSke0_oKFxGPIzO22ZkV7lUPNOg9rAMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/devices/index.vue?macro=true";
import { default as indexI8amtYKtVSikG2t5oWOZrsjeWaTe3aO7_45KqUVd3bUIEMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/workers/index.vue?macro=true";
import { default as indexoeq6bY6Wadu01tDlp24sfKbAw21uaJtw3E7U_45AcH730Meta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/external-services/index.vue?macro=true";
import { default as indexLkal3QEt9nEIy2RTfhwFVclCE7rr9ErR4Lo_45KJLUqL0Meta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/calendar/index.vue?macro=true";
import { default as createxKI7l401GYhwnJmLS7N3YptVZkaWMvYB24vc_ubAv_YMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/create.vue?macro=true";
import { default as editn30iqMdO2Zq5lUxdPXetWS3IJSpE_Vnz_45ArSxPpVFCYMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/cars/[id]/edit.vue?macro=true";
import { default as createGi_45kQV270edE4P5Du7oW3bUMKFpwNii_45pHfwGI2g9CcMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/devices/create.vue?macro=true";
import { default as createthSdoQ8J5J9k8vaUoxhDlwV6D8GU8LukTkGRCb5VJpEMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/workers/create.vue?macro=true";
import { default as createSrhETH58aaa0CQKeG9JqWd6J8BtojNKRUPj0z2Y7TOgMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/external-services/create.vue?macro=true";
import { default as indexO2IOx6EH6IlHy1UTB52CDFhXyrXSTMrbqzB3M_q_45B3UMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/cars/[id]/index.vue?macro=true";
import { default as indexFmIEviGHm7DV0_453aLk63ebdNMlnvJsQpI_45xZ7_45FvC4IMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/exceptional/index.vue?macro=true";
import { default as editCvx5Kzf_bj0H_fiEIeBgL8fP8v1q3TVJ7iRwtKZtmuQMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/[id]/users/[user_id]/edit.vue?macro=true";
import { default as editOqZupuo86bqtWBIl_iy_iNEezP6jfnolytHTzp4KJk4Meta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/devices/[id]/edit.vue?macro=true";
import { default as editWArB5NTsKtvtklGx9dl1u_2KvNTPg23yWKdiZPFzLqAMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/workers/[id]/edit.vue?macro=true";
import { default as editx2qu6AmMEvN6R9qqJRcw0m1QO_rUZMPl8I_454_45WaFkn8Meta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/external-services/[id]/edit.vue?macro=true";
import { default as indexa_452a_45EE1m6xs8vsaBeFOVCrmMP_45ZYIDu8AczUjwx17sMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/devices/[id]/index.vue?macro=true";
import { default as indexZqvQ84YeQteM_E4xLPyIs8LKt4_3tAiXsGDUTsBm22wMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/workers/[id]/index.vue?macro=true";
import { default as editmbwy_45uJpg8tivTdCcS7NiFnRMcfHPTj4eWTiTUoxhmsMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/users/[id]/[company_id]/edit.vue?macro=true";
import { default as indexT81eb7zK1oTMlQf0Peog2n_mF3mdKff2k02I1AleqOQMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/external-services/index.vue?macro=true";
import { default as editEO0F2UNujkvayWj5wKFdKidI22BzGA_p16iI0MxikPQMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/subjects/[subject_id]/edit.vue?macro=true";
import { default as createp2TlAijvPZ_SRaHZEANKrXkt0AiDI4fdYanY_3vZKrYMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/external-services/create.vue?macro=true";
import { default as indexUMkdEpL3ecipchVosixa6Zvftb0PRJmeDQo09_45K0Y40Meta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/subjects/[subject_id]/index.vue?macro=true";
import { default as editItbjXJhttoSgId069i3wkyFJlpb5i9O_4PKv0mxFnfUMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/external-services/[id]/edit.vue?macro=true";
import { default as createRuerQz9C8QCBrKdp5ElSLeL8gGt8KPGg1LJI0nf14d8Meta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/waste-customer-contracts/create.vue?macro=true";
import { default as editY4tdAgsVYKhs3kqDJ_BkVovL9m4DdyDd9_45QgJmSV2uIMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/waste-customer-contracts/[contract_id]/edit.vue?macro=true";
import { default as editZ0Aleh5jesgbXCm6_45ho9vkvFpykY7ECVGJlapLkh6rQMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/[waste_collection_routes_regular_id]/edit.vue?macro=true";
import { default as index1XX5YdO_45jkV04W7gw22lsoni_0THnQKJcy69Q2vMm7EMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/[waste_collection_routes_regular_id]/index.vue?macro=true";
import { default as indexIeCtZ4zvuTqGNETfTDrnNZbqXJ6Ose6gg9ukXB9UolUMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/exceptional/[waste_collection_routes_exceptional_id]/index.vue?macro=true";
import { default as indexuHeOJL0iMnxzgQm7Eowt4Ro3Ve_45_453C98qzTok3w1_45MAMeta } from "/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/[waste_collection_routes_regular_id]/waste-collections/[collection_id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginXKB97NmOaGKbgGwetMFpfnWx4CNCi0dLuLZt1yebgcsMeta || {},
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/login.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/profile.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/dashboard/index.vue")
  },
  {
    name: "waste-companies",
    path: "/waste-companies",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/index.vue")
  },
  {
    name: "waste-customers",
    path: "/waste-customers",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/index.vue")
  },
  {
    name: "waste-companies-create",
    path: "/waste-companies/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/create.vue")
  },
  {
    name: "waste-customers-create",
    path: "/waste-customers/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/create.vue")
  },
  {
    name: "waste-customers-export",
    path: "/waste-customers/export",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/export.vue")
  },
  {
    name: "waste-customers-import",
    path: "/waste-customers/import",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/import.vue")
  },
  {
    name: "waste-companies-id-edit",
    path: "/waste-companies/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/[id]/edit.vue")
  },
  {
    name: "waste-customers-id-edit",
    path: "/waste-customers/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/edit.vue")
  },
  {
    name: "administration-users",
    path: "/administration/users",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/users/index.vue")
  },
  {
    name: "waste-companies-id",
    path: "/waste-companies/:id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/[id]/index.vue")
  },
  {
    name: "waste-customers-id",
    path: "/waste-customers/:id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/index.vue")
  },
  {
    name: "administration-users-create",
    path: "/administration/users/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/users/create.vue")
  },
  {
    name: "administration-devices",
    path: "/administration/devices",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/devices/index.vue")
  },
  {
    name: "waste-evidence-headers",
    path: "/waste-evidence-headers",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-evidence-headers/index.vue")
  },
  {
    name: "administration-devices-create",
    path: "/administration/devices/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/devices/create.vue")
  },
  {
    name: "waste-evidence-headers-create",
    path: "/waste-evidence-headers/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-evidence-headers/create.vue")
  },
  {
    name: "administration-devices-id-edit",
    path: "/administration/devices/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/devices/[id]/edit.vue")
  },
  {
    name: "waste-evidence-headers-id-edit",
    path: "/waste-evidence-headers/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-evidence-headers/[id]/edit.vue")
  },
  {
    name: "administration-devices-id",
    path: "/administration/devices/:id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/devices/[id]/index.vue")
  },
  {
    name: "waste-companies-id-users-create",
    path: "/waste-companies/:id()/users/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/[id]/users/create.vue")
  },
  {
    name: "waste-evidence-headers-id",
    path: "/waste-evidence-headers/:id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-evidence-headers/[id]/index.vue")
  },
  {
    name: "waste-company-resources-cars",
    path: "/waste-company-resources/cars",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/cars/index.vue")
  },
  {
    name: "waste-company-resources-cars-create",
    path: "/waste-company-resources/cars/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/cars/create.vue")
  },
  {
    name: "waste-customers-id-subjects-create",
    path: "/waste-customers/:id()/subjects/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/subjects/create.vue")
  },
  {
    name: "waste-collection-routes-regular",
    path: "/waste-collection-routes/regular",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/index.vue")
  },
  {
    name: "waste-company-resources-devices",
    path: "/waste-company-resources/devices",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/devices/index.vue")
  },
  {
    name: "waste-company-resources-workers",
    path: "/waste-company-resources/workers",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/workers/index.vue")
  },
  {
    name: "administration-external-services",
    path: "/administration/external-services",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/external-services/index.vue")
  },
  {
    name: "waste-collection-routes-calendar",
    path: "/waste-collection-routes/calendar",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/calendar/index.vue")
  },
  {
    name: "waste-collection-routes-regular-create",
    path: "/waste-collection-routes/regular/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/create.vue")
  },
  {
    name: "waste-company-resources-cars-id-edit",
    path: "/waste-company-resources/cars/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/cars/[id]/edit.vue")
  },
  {
    name: "waste-company-resources-devices-create",
    path: "/waste-company-resources/devices/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/devices/create.vue")
  },
  {
    name: "waste-company-resources-workers-create",
    path: "/waste-company-resources/workers/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/workers/create.vue")
  },
  {
    name: "administration-external-services-create",
    path: "/administration/external-services/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/external-services/create.vue")
  },
  {
    name: "waste-company-resources-cars-id",
    path: "/waste-company-resources/cars/:id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/cars/[id]/index.vue")
  },
  {
    name: "waste-collection-routes-exceptional",
    path: "/waste-collection-routes/exceptional",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/exceptional/index.vue")
  },
  {
    name: "waste-companies-id-users-user_id-edit",
    path: "/waste-companies/:id()/users/:user_id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-companies/[id]/users/[user_id]/edit.vue")
  },
  {
    name: "waste-company-resources-devices-id-edit",
    path: "/waste-company-resources/devices/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/devices/[id]/edit.vue")
  },
  {
    name: "waste-company-resources-workers-id-edit",
    path: "/waste-company-resources/workers/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/workers/[id]/edit.vue")
  },
  {
    name: "administration-external-services-id-edit",
    path: "/administration/external-services/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/external-services/[id]/edit.vue")
  },
  {
    name: "waste-company-resources-devices-id",
    path: "/waste-company-resources/devices/:id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/devices/[id]/index.vue")
  },
  {
    name: "waste-company-resources-workers-id",
    path: "/waste-company-resources/workers/:id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/workers/[id]/index.vue")
  },
  {
    name: "administration-users-id-company_id-edit",
    path: "/administration/users/:id()/:company_id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/administration/users/[id]/[company_id]/edit.vue")
  },
  {
    name: "waste-company-resources-external-services",
    path: "/waste-company-resources/external-services",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/external-services/index.vue")
  },
  {
    name: "waste-customers-id-subjects-subject_id-edit",
    path: "/waste-customers/:id()/subjects/:subject_id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/subjects/[subject_id]/edit.vue")
  },
  {
    name: "waste-company-resources-external-services-create",
    path: "/waste-company-resources/external-services/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/external-services/create.vue")
  },
  {
    name: "waste-customers-id-subjects-subject_id",
    path: "/waste-customers/:id()/subjects/:subject_id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/subjects/[subject_id]/index.vue")
  },
  {
    name: "waste-company-resources-external-services-id-edit",
    path: "/waste-company-resources/external-services/:id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-company-resources/external-services/[id]/edit.vue")
  },
  {
    name: "waste-customers-id-waste-customer-contracts-create",
    path: "/waste-customers/:id()/waste-customer-contracts/create",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/waste-customer-contracts/create.vue")
  },
  {
    name: "waste-customers-id-waste-customer-contracts-contract_id-edit",
    path: "/waste-customers/:id()/waste-customer-contracts/:contract_id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-customers/[id]/waste-customer-contracts/[contract_id]/edit.vue")
  },
  {
    name: "waste-collection-routes-regular-waste_collection_routes_regular_id-edit",
    path: "/waste-collection-routes/regular/:waste_collection_routes_regular_id()/edit",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/[waste_collection_routes_regular_id]/edit.vue")
  },
  {
    name: "waste-collection-routes-regular-waste_collection_routes_regular_id",
    path: "/waste-collection-routes/regular/:waste_collection_routes_regular_id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/[waste_collection_routes_regular_id]/index.vue")
  },
  {
    name: "waste-collection-routes-exceptional-waste_collection_routes_exceptional_id",
    path: "/waste-collection-routes/exceptional/:waste_collection_routes_exceptional_id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/exceptional/[waste_collection_routes_exceptional_id]/index.vue")
  },
  {
    name: "waste-collection-routes-regular-waste_collection_routes_regular_id-waste-collections-collection_id",
    path: "/waste-collection-routes/regular/:waste_collection_routes_regular_id()/waste-collections/:collection_id()",
    component: () => import("/home/ingtomaszatloukal/snadnee/jrk-ts/.vapor/build/app/resources/nuxt/admin/pages/waste-collection-routes/regular/[waste_collection_routes_regular_id]/waste-collections/[collection_id]/index.vue")
  }
]